<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <div style="overflow:auto" class="mt-2">
            <b-table
              id="dynamic-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
            >
              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:thead-top="data">
                <tr>
                  <th>&nbsp;</th>
                  <th colspan="4" class="text-center bg-info text-white">{{$t('Valid Tickets')}}</th>
                  <th
                    colspan="4"
                    class="text-center bg-danger text-white"
                  >{{$t('Canceled Tickets')}}</th>
                  <th
                    colspan="4"
                    class="text-center bg-success text-white"
                  >{{$t('Winning Tickets')}}</th>
                </tr>
              </template>

              <template v-slot:head(esystem_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(valid_count)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(valid_amount)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(valid_stake)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(valid_tax)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(canceled_count)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(canceled_amount)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(canceled_stake)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(canceled_tax)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(win_count)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(win_gross_amount)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(win_net_amount)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(win_tax)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(profit)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(profit_pct)="data">{{ $t(data.label) }}</template>

              <template v-slot:cell(valid_amount)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(valid_stake)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(valid_tax)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(canceled_amount)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(canceled_stake)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(canceled_tax)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(win_gross_amount)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(win_net_amount)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(win_tax)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(profit)="data">{{ round(data.value) }}</template>
              <template v-slot:cell(profit_pct)="data">{{ round(data.value) }}</template>

              <template v-slot:cell(esystem_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/lottery-systems/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'dynamic-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";

export default {
  name: "lotterySystemsPerformance",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "lotterySystemsPerformance",
      filterOptions: [
        {
          field: "test",
          multiple: false,
          placeholder: "Test",
          options: [
            { name: "Test Mode", value: true },
            { name: "Live Mode", value: false }
          ],
          selected: [{ name: "Live Mode", value: false }]
        },
        {
          field: "save_time",
          type: "date",
          opens: "right",
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          ranges: {
            "Last hour": [moment().subtract(1, "hour"), moment()],
            "Last 6 hours": [moment().subtract(6, "hours"), moment()],
            "Last 24 hours": [moment().subtract(24, "hours"), moment()],
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment()
                .subtract(1, "days")
                .startOf("day"),
              moment()
                .subtract(1, "days")
                .endOf("day")
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek")
            ],
            "Last week": [
              moment()
                .subtract(1, "week")
                .startOf("isoWeek"),
              moment()
                .subtract(1, "week")
                .endOf("isoWeek")
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .subtract(1, "month")
                .endOf("month")
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()]
          }
        }
      ],
      isBusy: false,
      sortBy: "valid_count",
      sortDesc: true,
      fields: [
        {
          key: "esystem_id",
          label: "System",
          sortable: false,
          ignore: true,
          class: ""
        },
        {
          key: "valid_count",
          sortable: true,
          ignore: true,
          class: "",
          variant: "info"
        },
        {
          key: "valid_amount",
          sortable: true,
          ignore: true,
          class: "",
          variant: "info"
        },
        {
          key: "valid_stake",
          sortable: true,
          ignore: true,
          class: "",
          variant: "info"
        },
        {
          key: "valid_tax",
          sortable: true,
          ignore: true,
          class: "",
          variant: "info"
        },
        {
          key: "canceled_count",
          sortable: true,
          ignore: true,
          class: "",
          variant: "danger"
        },
        {
          key: "canceled_amount",
          sortable: true,
          ignore: true,
          class: "",
          variant: "danger"
        },
        {
          key: "canceled_stake",
          sortable: true,
          ignore: true,
          class: "",
          variant: "danger"
        },
        {
          key: "canceled_tax",
          sortable: true,
          ignore: true,
          class: "",
          variant: "danger"
        },
        {
          key: "win_count",
          sortable: true,
          ignore: true,
          class: "",
          variant: "success"
        },
        {
          key: "win_gross_amount",
          sortable: true,
          ignore: true,
          class: "",
          variant: "success"
        },
        {
          key: "win_net_amount",
          sortable: true,
          ignore: true,
          class: "",
          variant: "success"
        },
        {
          key: "win_tax",
          sortable: true,
          ignore: true,
          class: "",
          variant: "success"
        },
        {
          key: "profit",
          sortable: false,
          ignore: true,
          class: "",
          variant: "warning"
        },
        {
          key: "profit_pct",
          label: "Profit Percentage",
          sortable: false,
          ignore: true,
          class: "",
          variant: "warning"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: ""
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["lotterySystemPerformance/endpoint"];

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["esystem_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "dynamic-table");
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length) {
          exactFields.push(item.field);
          exactValues.push(item.selected);
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("day");
            paginationData.dateEnd = moment().endOf("day");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }
      return paginationData;
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();

      const lotterySytemByID = this.$store.getters["cache/lotterySytemByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "lotterySystems").catch(e => e)
      ]).finally(() => {
        this.$store
          .dispatch("lotterySystemPerformance/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.esystem_id) {
                const data = lotterySytemByID(item.esystem_id);
                if (data) {
                  item.esystem_id = {
                    to: item.esystem_id,
                    name: data.name
                  };
                } else {
                  item.esystem_id = {
                    to: null,
                    name: item.esystem_id
                  };
                }
              }
            });
            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(
                err.details && err.details.length ? err.details[0] : err.message
              ),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      //this.$router.push("/lottery-systems-performance/" + item.eid);
    },
    redirect() {}
  }
};
</script>

<style lang="scss" scoped>
</style>


